var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWarning)?_c('div',{staticClass:"bodyImg",on:{"click":_vm.hideImage}},[_c('img',{attrs:{"src":require("./../assets/browser-warning.png"),"width":"100%","alt":"请在浏览器中打开此页面"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }